import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import { HTTP } from '../../api/resources';
import Select from 'react-select'
import CreateTemplateModal from '../Helpers/Modal/Forms/CreateTemplateModal';
import InfoModal from './Modals/InfoModal';

function Settings(props) {
  const [loading, setLoading] = useState(false)
  const [limit, setLimit] = useState(0)
  const [isDirty, setDirty] = useState(false)
  const [useMedia, setMedia] = useState(false)
  const [addDonor, setDonor] = useState(true)
  const [skipPostSummary, setSkipPostSummary] = useState(false)
  const [addBeneficiary, setBeneficiary] = useState(true)
  const [templates, setTemplates] = useState(props.templates)
  const [selectedTemplates, setSelectedTemplates] = useState(null)
  const [useTemplate, setUseTemplate] = useState(false)
  const [createTemplateModal, setCreateTemplateModal] = useState(false)
  const [savingTemplate, setSavingTemplate] = useState(false)
  const [autoSelectMedia, setAutoSelectMedia] = useState(false)
  const [openMediaSelectionGuide, setOpenMediaSelectionGuide] = useState(false)
  const team = props.team
  const user = props.user

  useEffect(() => {
    if (limit > 1500) {
      Alert.show('notice', 'You can set a maximum of 1500 posts')
      setLimit(0)
    }
  }, [limit])

  window.onbeforeunload = (event) => {
    if (isDirty) return ''
  }

  const proceed = async () => {
    setLoading(true)

    // ensure data is correct before passing
    if (limit < 1) {
      setLimit(0)
      Alert.show('notice', 'Limit cannot be less than 1')
      setLoading(false)
      return true
    } else if (!addDonor && !addBeneficiary) {
      setLoading(false)
      Alert.show('notice', 'Please select one or more user types')
      return ''
    }

    if (useTemplate && !selectedTemplates) {
      Alert.show('notice', 'A template must be choosen if use template is selected')
      setLoading(false)
      return ''
    }

    // create data object
    const data = {
      limit: limit,
      add_donor: addDonor,
      add_beneficiary: addBeneficiary,
      use_media: useMedia,
      skip_post_summary: skipPostSummary,
      template_id: selectedTemplates ? selectedTemplates.id : null,
      use_template: useTemplate,
      auto_select_media: autoSelectMedia
    }

    // send and handle response from server if validations pass
      try {
        await saveSettings(data)
      } catch {
        setLoading(false)
        Alert.show('error', 'Error saving settings, try again')
        return ''
      }

      setLoading(false)
      setDirty(false)
      Alert.show('notice', 'Settings saved successfully')
      setTimeout(() => redirect(), 1500)
  }

  // determine where to redirect on success
  const redirect = () => {
    if (useMedia) window.location = '/group/post/media'
    else window.location = '/group/post/form'
  }

  // to send data to the server
  const saveSettings = (data) => {
    return HTTP.post('/group/post/settings', data)
  }

  const createNewTemplate = async (template) => {
    setSavingTemplate(true)

    try {
      let response = await templateRequest(template)
      setTemplates(response.data.templates)
      setSelectedTemplates(response.data.template)
      Alert.show('show', 'Template created and saved successfully')
      setCreateTemplateModal(false)
      setSavingTemplate(false)
    } catch {
      Alert.show('error', 'Failed to create template, please try again')
      setSavingTemplate(false)
    }
  }

  const templateRequest = (data) => {
    return HTTP.post('/group/post/settings/templates', data)
  }


  return (
    <div>
      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">
            Settings
          </h4>

          <div>
            <a href="/group/post" className="btn btn-danger mr-1">
              Cancel
            </a>
            <button onClick={proceed} name="button" className="btn btn-primary">
              {loading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
              Proceed
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="limit">Post Amount</label>
                <input className="form-control" placeholder="Post amount less than 500" type="number" name="limit" id="limit"
                  value={limit}
                  onChange={e => {
                    const val = e.target.value;
                    setLimit(val)
                    setDirty(true)
                  }}
                />
              </div>


              {useTemplate &&
                <div className="form-group" role="group" aria-labelledby="postAsLabel">
                  <label id="postAsLabel">Select Default Template</label>
                  <div className="input-group">
                    <Select
                      className="w-100"
                      onChange={(template) => {
                        setSelectedTemplates(template)
                      }}
                      options={templates}
                      getOptionLabel={(template) =>
                        `${template.title}`
                      }
                      getOptionValue={(template) => template.id}
                      value={selectedTemplates}
                    />
                  </div>
                </div>
              }

              {!useTemplate &&
                <div className="form-group" role="group" aria-labelledby="postAsLabel">
                  <label id="postAsLabel">Select Default Template</label>
                  <div className="input-group">
                    <Select
                      className="w-100"
                      onChange={(template) => {
                        setSelectedTemplates(template)
                      }}
                      options={templates}
                      getOptionLabel={(template) =>
                        `${template.title}`
                      }
                      getOptionValue={(template) => template.id}
                      value={selectedTemplates}
                      isDisabled
                    />
                  </div>
                  <small>Turn on the default template feature to unlock</small>
                </div>
              }

              <div className='form-group'>
                <button 
                  onClick={() => setCreateTemplateModal(true)} 
                  name="button" 
                  className="btn btn-primary"
                  disabled={!useTemplate}
                >
                  + Create New Template
                </button>
              </div>


            </div>
            <div className="col-md-6">
              <div className="form-group">
                <div>
                  <ToggleSwitch
                    small
                    checked = {addDonor}
                    id="donor"
                    onChange={checked => {
                        setDonor(checked)
                        setDirty(true)
                      }
                    }
                  />
                  <label style={{textTransform: 'capitalize'}} htmlFor="donor">Add { team.translations.donor_title } to the sender list</label>
                </div>
                <div className="description mb-4">
                  <small>
                    This will add all your { team.translations.donor_title.toLowerCase() } to the senders list, 
                    allowing you to select them as a sender
                  </small>
                </div>

                <div>
                  <ToggleSwitch
                    small
                    checked = {addBeneficiary}
                    id="beneficiary"
                    onChange={checked => {
                        setBeneficiary(checked)
                        setDirty(true)
                      }
                    }
                  />
                  <label style={{textTransform: 'capitalize'}} htmlFor="beneficiary">Add { team.translations.beneficiary_title } to the sender list</label>
                </div>
                <div className="description mb-4">
                  <small>
                    This will add all your { team.translations.beneficiary_title.toLowerCase() } to the senders list, 
                    allowing you to select them as a sender
                  </small>
                </div>

                <div>
                  <ToggleSwitch
                    small
                    id="media"
                    onChange={checked => {
                        setMedia(checked)
                        setDirty(true)
                      }
                    }
                  />
                  <label style={{textTransform: 'capitalize'}} htmlFor="media">Use media files in post</label>
                </div>
                <div className="description mb-4">
                  <small>
                    Allows you to mass upload media assets at the start and you can then select some/all of the media assets 
                    for a post, you can also add additional media assets mid-post. 
                    <b><i> (required to use the auto select media files feature)</i></b>
                  </small>
                </div>
                {useMedia && 
                  <div>
                    <div>
                      <ToggleSwitch
                        small
                        id="auto_select_media"
                        onChange={checked => {
                            if (checked && !autoSelectMedia) {
                              setOpenMediaSelectionGuide(true)
                            }
                            setAutoSelectMedia(checked)
                            setDirty(true)
                          }
                        }
                        disabled={!useMedia}
                      />
                      <label style={{textTransform: 'capitalize'}} htmlFor="auto_select_media">
                        Auto select media files
                      </label>
                    </div>
                    <div className="description mb-4">
                      <small>
                        We will automatically select the media files that their title match the Import ID of the post sender,
                        you can still manually add and remove media files for the post. 
                        <b>Toggle this on to get further instructions</b> 
                      </small>
                    </div>
                  </div>
                }
                <div>
                  <ToggleSwitch
                    small
                    id="skip_post_summary"
                    onChange={checked => {
                        setSkipPostSummary(checked)
                        setDirty(true)
                      }
                    }
                  />
                  <label style={{textTransform: 'capitalize'}} htmlFor="skip_post_summary">Skip post summaries</label>
                </div>
                <div className="description mb-4">
                  <small>
                    Post summaries serve as an extra confirmation before the post can be saved, you can choose to skip the post 
                    summaries for {team.translations.beneficiary_title.toLowerCase()} and {team.translations.donor_title.toLowerCase()}
                  </small>
                </div>

                <div>
                  <ToggleSwitch
                    small
                    id="use_template"
                    onChange={checked => {
                        setUseTemplate(checked)
                        setDirty(true)
                      }
                    }
                  />
                  <label style={{textTransform: 'capitalize'}} htmlFor="use_template">Use Default Template</label>
                </div>
                <div className="description mb-4">
                  <small>
                    You can select a default template from here and it will be automatically prefilled to all your 
                    posts, you cannot select or change the default template mid-post but can always 
                    deactivate and reactivate it
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {createTemplateModal &&
        <CreateTemplateModal 
          close={() => setCreateTemplateModal(false)} 
          create={(template) => createNewTemplate(template)} 
          saving={savingTemplate}
        />
      }

      {openMediaSelectionGuide &&
        <InfoModal team={team} close={() => setOpenMediaSelectionGuide(false)} />
      }
    </div>
  )
}

export default Settings
